/**
 * Khối compute: cấu trúc thị trường (Pivot Standard, Pivot High/Low, Wyckoff Wave).
 *
 * Một nhóm trong `computeIndicatorComputationResult`, tách riêng (split 2026-09-30).
 * Cả ba đều vẽ mốc ngang/sóng theo toàn bộ lịch sử thay vì theo chu kỳ, nên chúng
 * không thuộc nhóm dao động dù đều là "chỉ báo tham số theo khoá".
 */
import { pivotHighLowSeries, pivotStandardSeries } from "../../indicators/utils";
import { computeWyckoffWave } from "../../indicators/builtin/wyckoffWave";
export function computeMarketStructureBlocks(raw, plan) {
    const pivotStandardByKey = new Map();
    for (const [key, config] of plan.pivotStandardConfigs) {
        const typesStr = ["standard", "fibonacci", "camarilla", "woodie", "demark"];
        const typeStr = typesStr[config.pivotType] || "standard";
        const series = pivotStandardSeries(raw, typeStr);
        pivotStandardByKey.set(key, raw.map((_, index) => {
            const pp = series.pp[index];
            if (pp === undefined || isNaN(pp))
                return undefined;
            return {
                pp,
                r1: series.r1[index],
                s1: series.s1[index],
                r2: series.r2[index],
                s2: series.s2[index],
                r3: series.r3[index],
                s3: series.s3[index],
            };
        }));
    }
    const pivotHighLowByKey = new Map();
    for (const [key, config] of plan.pivotHighLowConfigs) {
        const typesStr = ["standard", "fibonacci"];
        const typeStr = typesStr[config.pivotType] || "standard";
        const series = pivotHighLowSeries(raw, config.lookback, typeStr);
        pivotHighLowByKey.set(key, raw.map((_, index) => {
            const pp = series.pp[index];
            if (pp === undefined || isNaN(pp))
                return undefined;
            return {
                pp,
                r1: series.r1[index],
                s1: series.s1[index],
                r2: series.r2[index],
                s2: series.s2[index],
                r3: series.r3[index],
                s3: series.s3[index],
            };
        }));
    }
    const wyckoffWaveByKey = new Map();
    for (const [key, config] of plan.wyckoffWaveConfigs) {
        const wyckoffValues = computeWyckoffWave(raw, config.thresholdPercent);
        wyckoffWaveByKey.set(key, wyckoffValues);
    }
    return {
        pivotStandardByKey,
        pivotHighLowByKey,
        wyckoffWaveByKey,
    };
}
